<template>
    <q-card-section class="modal-content" >
        <div class="d-flex justify-between modal-title-wrapper">
            <span class="modal-title">Отзыв о товаре</span>

            <div class="testimonial-rating">
                <div class="testimonial-rating-item">
                    <span>Оценка</span>
                    <q-rating
                        v-model="form.rating"
                        size="3.5em"
                        color="primary"
                        @input="form.errors.clear('rating')"
                        :class="[{ 'has-error': form.errors.has('rating') }, 'required']"
                    ></q-rating>
                    <div v-if="form.errors.has('rating')" class="text-negative">
                        {{ form.errors.get('rating') }}
                    </div>
                </div>
            </div>
        </div>

        <q-input
            outlined
            class="required"
            v-model="form.name"
            @input="form.errors.clear('name')"
            :error-message="form.errors.get('name')"
            :error="form.errors.has('name')"
            label="Ваше имя" />

        <q-input
            outlined
            v-model="form.city"
            @input="form.errors.clear('city')"
            :error-message="form.errors.get('city')"
            :error="form.errors.has('city')"
            label="Ваш город">
        </q-input>

        <q-input
            outlined
            label="Ваш отзыв"
            class="required"
            v-model="form.message"
            type="textarea"
            @input="form.errors.clear('message')"
            :error-message="form.errors.get('message')"
            :error="form.errors.has('message')"
        />

        <q-card-actions align="right" class="q-pa-none q-mt-sm">
            <q-btn class="full-width" label="Отправить" @click.prevent="submitReview" />
        </q-card-actions>
    </q-card-section>
</template>

<script>
    import { mapMutations } from 'vuex';
    import { Form } from "../../../classes/Form";

    export default {
        name: 'AddProductReview',
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data () {
            return {
                form: new Form({
                    name: '',
                    city: '',
                    message: '',
                    rating: 0,
                }),
            }
        },
        mounted () {
            if (this.$root.account()) {
                this.form.name = this.$root.account().first_name;
            }

            if (this.$root.cityName) {
                this.form.city = this.$root.cityName;
            }
        },
        watch: {
            '$root.cityName' (newVal, oldVal) {
                if (newVal) {
                    this.form.city = newVal;
                }
            }
        },
        methods: {
            ...mapMutations('product', [
                'hideFeedbackModal',
                'setExistUserReview',
            ]),

            submit () {
                let _this = this;

                _this.responseMessage = '';

                _this.form.post('/products/' + _this.id + '/reviews')
                    .then(response => {
                        _this.hideFeedbackModal();

                        _this.form.reset();

                        _this.$emit(
                            'submitted',
                            'Он появится на сайте после модерации',
                            'Спасибо за Ваш отзыв!'
                        );

                        _this.setExistUserReview(true);
                    });
            },

            submitReview () {
                let _this = this;
                _this.submit();
            }
        },
        computed: {
            modal: {
                get () {
                    return this.$store.state.product.modal === 'review';
                },
                set (value) {
                    this.hideFeedbackModal();
                }
            },
        }
    }
</script>
